export const ACTIVITY_VIEW_TYPES = ['updates', 'outcomes', 'all'] as const;
export type ActivityViewType = (typeof ACTIVITY_VIEW_TYPES)[number];

export const isActivityViewType = (v: unknown): v is ActivityViewType =>
  typeof v === 'string' && (ACTIVITY_VIEW_TYPES as readonly string[]).includes(v);
